import apiBusinessPartner from './apibusinesspartner';
// UK admin: only API Business Partner list + KYC approve in the left nav.
// Hidden (keep imports commented for easy restore):
// import adminUser from './adminUser';
// import adminTools from './adminTools';
// import dashboard from './dashboard';

// ==============================|| MENU ITEMS ||============================== //
function getMenuItems() {
  return {
    items: [
      apiBusinessPartner,
      // adminUser,
      // dashboard,
      // adminTools,
    ],
  };
}

export default getMenuItems;
